import { useFetchWithInterceptor } from '@/use'
import { toRaw } from 'vue'

/**
 * Fetches user permissions from the API.
 * @returns An array of permission strings.
 */
export const fetchUserPermissions = async (): Promise<string[]> => {
  const { response, request } = useFetchWithInterceptor<string[]>(
    `${import.meta.env.VITE_API_URL}/account/permissions`,
    {
      method: 'GET',
    },
  )

  await request()

  if (response.value) {
    return toRaw(response.value)
  } else {
    throw new Error('Failed to fetch user permissions.')
  }
}
